import { NameAddress } from './nameaddress.model';
import { PhoneNumber } from './phonenumber.model';

export class NameDtl {
    public NameID: string;
    public JurisID: number;
    public FirstName: string;
    public MiddleName: string;
    public LastName: string;
    public NameSuffix: string;
    public DOBDttmUTC: Date;
    public Sex: string;
    public Race: string;
    public Resident: string;
    public Ethnic: string;
    public Email: string;
    public Notes: string;
    public IsActive: number;
    public CreatedPFID: string;
    public CreatedDttmUTC: Date;
    public ModifiedPFID: string;
    public ModifiedDttmUTC: Date;
    public NameAddress: NameAddress;
    public PhoneNumber: PhoneNumber[];
    public SourceType: string;
    public SourceID?: number;
    public RegisteredPhoneNumber: PhoneNumber[]
    public BusinessID: string;
    public BusinessName: string;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/namedtl.model.ts